// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Currency Management */
.currency-loading,
.currency-error,
.currency-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem 1.5rem;
  color: var(--text-muted);
  font-size: 0.95rem;
  text-align: center;
}

.currency-empty .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.currency-alert {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.currency-alert--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.currency-alert--success {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.currency-muted {
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

.currency-file-preview {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  color: #16a34a;
  margin-top: 0.25rem;
  margin-left: 0.5rem;
}

.currency-chain-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.currency-chain-block {
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.currency-chain-block__title {
  margin: 0 0 0.75rem 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
}

.currency-management-hero {
  /* flex-wrap: wrap; */
  gap: 1rem;
}

.currency-management-hero__coin {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.4rem 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
}

.currency-management-hero__coin i {
  font-size: 1rem;
}

.currency-management-hero__select {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.currency-select-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.currency-select {
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  background: #fff;
  color: var(--text);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  min-width: 160px;
}

.currency-management-body {
  padding-bottom: 5rem;
  width: 100%;
}

.currency-form {
  width: 100%;
  max-width: none;
}

/* Collapsible sections */
.currency-section {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.currency-section__head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
  background: #f8fafc;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.2s;
}

.currency-section__head:hover {
  background: #f1f5f9;
}

.currency-section__head i:first-of-type {
  color: #0f766e;
  width: 1.25rem;
  text-align: center;
}

.currency-section__chevron {
  margin-left: auto;
  font-size: 0.8rem;
  color: var(--text-muted);
}

.currency-section__body {
  padding: 1.25rem;
  border-top: 1px solid var(--border);
}

/* Form fields */
.currency-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.currency-form-row:last-child {
  margin-bottom: 0;
}

.currency-form-row--3 {
  grid-template-columns: repeat(3, 1fr);
}

.currency-field {
  margin-bottom: 1rem;
}

.currency-field:last-child {
  margin-bottom: 0;
}

.currency-field label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text);
}

.currency-field input[type="text"],
.currency-field input[type="url"],
.currency-field select,
.currency-field textarea {
  width: 100%;
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.currency-field input:focus,
.currency-field select:focus,
.currency-field textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.currency-field textarea {
  resize: vertical;
  min-height: 80px;
}

.currency-hint {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* Tags */
.currency-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.currency-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.65rem;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
}

.currency-tag-remove {
  padding: 0 0.2rem;
  font-size: 1rem;
  line-height: 1;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  opacity: 0.8;
}

.currency-tag-remove:hover {
  opacity: 1;
}

/* Chain table */
.currency-chain-actions {
  margin-bottom: 1rem;
}

.currency-add-chain-select {
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
  min-width: 160px;
}

.currency-add-chain-select:focus {
  outline: none;
  border-color: #0f766e;
}

.currency-chain-actions-col {
  width: 48px;
  text-align: center;
  vertical-align: middle;
}

.currency-remove-chain {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: #fef2f2;
  color: #b91c1c;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
}

.currency-remove-chain:hover:not(:disabled) {
  background: #fee2e2;
}

.currency-remove-chain:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.currency-chain-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.currency-chain-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.currency-chain-table th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted);
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.currency-chain-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.currency-chain-table tbody tr:last-child td {
  border-bottom: none;
}

.currency-chain-table td input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
  border: 1px solid var(--border);
  border-radius: 6px;
}

.currency-chain-table td input:focus {
  outline: none;
  border-color: #0f766e;
}

.currency-contract-cell {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.currency-input--error {
  border-color: #dc2626 !important;
  background: #fef2f2;
}

.currency-field-error {
  font-size: 0.75rem;
  color: #b91c1c;
}

/* File upload */
.currency-file-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.currency-file-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  position: absolute;
}

.currency-file-label {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  background: #f1f5f9;
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.currency-file-label:hover {
  background: #e2e8f0;
}

.currency-file-text {
  font-size: 0.85rem;
  color: var(--text-muted);
}

/* Custom links */
.currency-link-row {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.75rem;
}

.currency-link-input {
  flex: 1 1;
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.btn-remove-link {
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
}

.btn-remove-link:hover {
  background: #fee2e2;
}

.btn-add-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f766e;
  background: #f0fdfa;
  border: 1px dashed #0f766e;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 0.5rem;
}

.btn-add-link:hover {
  background: #ccfbf1;
}

/* Footer – Update button */
.currency-form-footer {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem 0 1.5rem;
  background: linear-gradient(to top, var(--main-bg) 80%, transparent);
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.btn-update-currency {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.35);
  transition: opacity 0.2s, transform 0.15s;
}

.btn-update-currency:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

/* Confirmation modal */
.currency-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.currency-confirm-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 520px;
  width: 90%;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

.currency-confirm-title {
  margin: 0 0 0.75rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text);
}

.currency-confirm-text {
  margin: 0 0 1rem 0;
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.currency-changes-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  margin-bottom: 1.25rem;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid var(--border);
  max-height: 240px;
}

.currency-change-row {
  padding: 0.6rem 0;
  font-size: 0.85rem;
  border-bottom: 1px solid #e2e8f0;
}

.currency-change-row:last-child {
  border-bottom: none;
}

.currency-change-field {
  font-weight: 600;
  color: var(--text);
  display: block;
  margin-bottom: 0.25rem;
}

.currency-change-from,
.currency-change-arrow,
.currency-change-to {
  display: inline;
}

.currency-change-from {
  color: #b91c1c;
  word-break: break-all;
}

.currency-change-arrow {
  color: var(--text-muted);
  font-size: 0.7rem;
  margin: 0 0.35rem;
}

.currency-change-to {
  color: #15803d;
  word-break: break-all;
}

.currency-confirm-note {
  margin: 0 0 1.25rem 0;
  font-size: 0.9rem;
  color: var(--text-muted);
  font-style: italic;
}

.currency-confirm-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.btn-currency-cancel {
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-family: inherit;
  color: var(--text);
  background: #f1f5f9;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-currency-cancel:hover {
  background: #e2e8f0;
}

.btn-currency-confirm {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-currency-confirm:hover:not(:disabled) {
  opacity: 0.95;
}

.btn-currency-confirm:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .currency-form-row,
  .currency-form-row--3 {
    grid-template-columns: 1fr;
  }
}
.currency-section input{
  width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
    border: 1px solid var(--border);
    border-radius: 6px;
}
.currency-section select{
  width: 100%;
  padding: 0.6rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/CurrencyManagementPage.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,oEAAoE;EACpE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE,WAAW;IACT,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* Currency Management */\n.currency-loading,\n.currency-error,\n.currency-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 3rem 1.5rem;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n.currency-empty .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.currency-alert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.currency-alert--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.currency-alert--success {\n  background: #f0fdf4;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.currency-muted {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.currency-file-preview {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.8rem;\n  color: #16a34a;\n  margin-top: 0.25rem;\n  margin-left: 0.5rem;\n}\n\n.currency-chain-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.currency-chain-block {\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.currency-chain-block__title {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.currency-management-hero {\n  /* flex-wrap: wrap; */\n  gap: 1rem;\n}\n\n.currency-management-hero__coin {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  padding: 0.4rem 0.75rem;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n.currency-management-hero__coin i {\n  font-size: 1rem;\n}\n\n.currency-management-hero__select {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.currency-select-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.currency-select {\n  padding: 0.5rem 2rem 0.5rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  background: #fff;\n  color: var(--text);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  min-width: 160px;\n}\n\n.currency-management-body {\n  padding-bottom: 5rem;\n  width: 100%;\n}\n\n.currency-form {\n  width: 100%;\n  max-width: none;\n}\n\n/* Collapsible sections */\n.currency-section {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  margin-bottom: 1rem;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.currency-section__head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n  background: #f8fafc;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: background 0.2s;\n}\n\n.currency-section__head:hover {\n  background: #f1f5f9;\n}\n\n.currency-section__head i:first-of-type {\n  color: #0f766e;\n  width: 1.25rem;\n  text-align: center;\n}\n\n.currency-section__chevron {\n  margin-left: auto;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.currency-section__body {\n  padding: 1.25rem;\n  border-top: 1px solid var(--border);\n}\n\n/* Form fields */\n.currency-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.currency-form-row:last-child {\n  margin-bottom: 0;\n}\n\n.currency-form-row--3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.currency-field {\n  margin-bottom: 1rem;\n}\n\n.currency-field:last-child {\n  margin-bottom: 0;\n}\n\n.currency-field label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.currency-field input[type=\"text\"],\n.currency-field input[type=\"url\"],\n.currency-field select,\n.currency-field textarea {\n  width: 100%;\n  padding: 0.6rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.currency-field input:focus,\n.currency-field select:focus,\n.currency-field textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.currency-field textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.currency-hint {\n  display: block;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n/* Tags */\n.currency-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.currency-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.65rem;\n  background: #e0f2fe;\n  color: #0369a1;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.currency-tag-remove {\n  padding: 0 0.2rem;\n  font-size: 1rem;\n  line-height: 1;\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.currency-tag-remove:hover {\n  opacity: 1;\n}\n\n/* Chain table */\n.currency-chain-actions {\n  margin-bottom: 1rem;\n}\n\n.currency-add-chain-select {\n  padding: 0.5rem 2rem 0.5rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n  min-width: 160px;\n}\n\n.currency-add-chain-select:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.currency-chain-actions-col {\n  width: 48px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.currency-remove-chain {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: #fef2f2;\n  color: #b91c1c;\n  cursor: pointer;\n  transition: background 0.2s, opacity 0.2s;\n}\n\n.currency-remove-chain:hover:not(:disabled) {\n  background: #fee2e2;\n}\n\n.currency-remove-chain:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.currency-chain-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n}\n\n.currency-chain-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.currency-chain-table th {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--text-muted);\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.currency-chain-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n.currency-chain-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.currency-chain-table td input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.85rem;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n}\n\n.currency-chain-table td input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.currency-contract-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.currency-input--error {\n  border-color: #dc2626 !important;\n  background: #fef2f2;\n}\n\n.currency-field-error {\n  font-size: 0.75rem;\n  color: #b91c1c;\n}\n\n/* File upload */\n.currency-file-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.currency-file-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  position: absolute;\n}\n\n.currency-file-label {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  background: #f1f5f9;\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.currency-file-label:hover {\n  background: #e2e8f0;\n}\n\n.currency-file-text {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n/* Custom links */\n.currency-link-row {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.currency-link-input {\n  flex: 1;\n  padding: 0.6rem 1rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n}\n\n.btn-remove-link {\n  padding: 0.5rem 1rem;\n  font-size: 0.85rem;\n  color: #b91c1c;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.btn-remove-link:hover {\n  background: #fee2e2;\n}\n\n.btn-add-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0f766e;\n  background: #f0fdfa;\n  border: 1px dashed #0f766e;\n  border-radius: 8px;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.btn-add-link:hover {\n  background: #ccfbf1;\n}\n\n/* Footer – Update button */\n.currency-form-footer {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 1rem 0 1.5rem;\n  background: linear-gradient(to top, var(--main-bg) 80%, transparent);\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n.btn-update-currency {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.35);\n  transition: opacity 0.2s, transform 0.15s;\n}\n\n.btn-update-currency:hover {\n  opacity: 0.95;\n  transform: translateY(-1px);\n}\n\n/* Confirmation modal */\n.currency-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.currency-confirm-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 520px;\n  width: 90%;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n\n.currency-confirm-title {\n  margin: 0 0 0.75rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.currency-confirm-text {\n  margin: 0 0 1rem 0;\n  font-size: 0.95rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.currency-changes-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  margin-bottom: 1.25rem;\n  padding: 0.75rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  max-height: 240px;\n}\n\n.currency-change-row {\n  padding: 0.6rem 0;\n  font-size: 0.85rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.currency-change-row:last-child {\n  border-bottom: none;\n}\n\n.currency-change-field {\n  font-weight: 600;\n  color: var(--text);\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.currency-change-from,\n.currency-change-arrow,\n.currency-change-to {\n  display: inline;\n}\n\n.currency-change-from {\n  color: #b91c1c;\n  word-break: break-all;\n}\n\n.currency-change-arrow {\n  color: var(--text-muted);\n  font-size: 0.7rem;\n  margin: 0 0.35rem;\n}\n\n.currency-change-to {\n  color: #15803d;\n  word-break: break-all;\n}\n\n.currency-confirm-note {\n  margin: 0 0 1.25rem 0;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n.currency-confirm-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.btn-currency-cancel {\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  color: var(--text);\n  background: #f1f5f9;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-currency-cancel:hover {\n  background: #e2e8f0;\n}\n\n.btn-currency-confirm {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.btn-currency-confirm:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.btn-currency-confirm:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .currency-form-row,\n  .currency-form-row--3 {\n    grid-template-columns: 1fr;\n  }\n}\n.currency-section input{\n  width: 100%;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n    border: 1px solid var(--border);\n    border-radius: 6px;\n}\n.currency-section select{\n  width: 100%;\n  padding: 0.6rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
